import {TweenMax} from "gsap";
import {TimelineMax} from "gsap";
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
const controller = new ScrollMagic.Controller;
/**
 * footer
 * @constructor
 */
class Footer {
  constructor() {}
  /**
   * コモン
   */
  init() {
    
    //footer メニュー内のアコーディオン sp
    $('.js-acc-trigger').on('click', function () {
      $(this).next().stop().slideToggle();
      $(this).toggleClass('active');
    })
    //footer 拠点一覧のアコーディオン pc
    $('.js-hub-ttl').on('click', function () {
      $(this).next().stop().slideToggle();
      $(this).toggleClass('active');
    })
      
  }

}

export default Footer;
